import { useCallback } from "react";

import {
	useAddPaymentMethodMutation,
	useUpdatePaymentMethodMutation,
} from "queries";

import { getMappedPaymentMethodForm } from "./getMappedPaymentMethodForm";

type AddPaymentMethodMutationProps = {
	mutateAsync: Function;
	isLoading?: boolean;
};

const useSubmitPaymentMethod = ({
	onSuccess,
	submitService,
}: {
	onSuccess: Function;
	submitService: Function;
	paymentMethodId?: string;
}) => {
	const { mutateAsync: submitAdd }: AddPaymentMethodMutationProps =
		useAddPaymentMethodMutation({
			onSuccess,
			submitService,
		});

	const { mutateAsync: submitUpdate }: AddPaymentMethodMutationProps =
		useUpdatePaymentMethodMutation({
			onSuccess,
			submitService,
		});

	return useCallback(
		async function submitPage(formValues, entityId, paymentMethodId) {
			const data = getMappedPaymentMethodForm(formValues);

			if (!paymentMethodId) {
				submitAdd({ data, id: entityId });
			} else {
				submitUpdate({
					data,
					id: entityId,
					paymentMethodId,
				});
			}
		},
		[submitAdd, submitUpdate],
	);
};

export default useSubmitPaymentMethod;
